const numberFormatter = new Intl.NumberFormat();
export function StatisticBlock({ title, value }: { title: string; value?: number }) {
  return (
    <div className="flex min-w-min flex-col justify-between rounded-lg border bg-gradient-to-b from-gray-50 to-gray-100 p-4.5 px-5 pb-3.5 shadow-lg/2">
      <p className="mb-3 text-gray-500">{title}</p>
      <p className="animate-in fade-in h-11 text-4xl font-semibold text-gray-800">
        {value !== undefined ? (
          numberFormatter.format(value)
        ) : (
          <span className="animate-in fade-in block h-full w-24 animate-pulse rounded-lg bg-gray-200"></span>
        )}
      </p>
    </div>
  );
}
